const BASE64_BLOCK_LENGTH = 4;

const base64UrlToBase64 = (segment: string): string => {
  const base64 = segment.replaceAll('-', '+').replaceAll('_', '/');
  const paddedLength = Math.ceil(base64.length / BASE64_BLOCK_LENGTH) * BASE64_BLOCK_LENGTH;
  return base64.padEnd(paddedLength, '=');
};

export const decodeJwtPayload = (token: string): Record<string, unknown> => {
  const payload = token.split('.')[1];
  if (!payload) {
    throw new Error('The token has no payload segment');
  }
  const bytes = Uint8Array.from(atob(base64UrlToBase64(payload)), char => char.codePointAt(0) ?? 0);
  return JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes));
};
